import React, {memo, useState, useCallback, useContext} from 'react';
import { Circle, Group, Stage, FastLayer, Rect, Line} from 'react-konva';
import {getYPositionFromValue} from './position.js';

window.guideColor = '#272a2e';

export default memo(({
    height,
    xScale,
    width,
    selectedParameter,
    track
}) => {
    if (selectedParameter === undefined) {
        return [];
    }
    let min = selectedParameter.min;
    let max = selectedParameter.max;

    let values = [];
    let distance = max - min;
    let num = 10.0;
    let part = distance / num;

    for (let i=0; i < num; i++) {
        let position = getYPositionFromValue(min + part * i, height, min, max);
        values.push(position);
    }

    let defaultPosition =  getYPositionFromValue(selectedParameter.config.defaultValue, height, min, max);

    return [...
          values.map(
              position =>
                  <line x1={0} y1={position} x2={width} y2={position} stroke={window.guideColor} strokeWidth={1}/>
          ),
            <line x1={0} y1={defaultPosition} x2={width} y2={defaultPosition} stroke="#3e434a" strokeWidth={1}/>
        ];
});
